<template>

    <div id="homeBox">
        <div style="  margin: 5px 0;">

            <el-date-picker
                    style="width:210px; margin-right: 9px; margin-left: 9px;"
                    size="mini"
                    :clearable="false"
                    :unlink-panels="true"
                    v-model="searchTime"
                    type="daterange"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="dateChange">
            </el-date-picker>
            <el-select v-model="state" size="mini" @change="chooseStatus" style="margin-right: 9px;">
                <el-option v-for="item in stateList" :key="item.key" :label="item.label" :value="item.key"></el-option>
            </el-select>
            <el-input style="width: 220px" class="marr4" size="mini" placeholder="搜索队列名/业务类型"  v-model="vc_search">
                <el-button slot="append" icon="el-icon-search" @click="chooseStatus"></el-button>
            </el-input>
        </div>
        <el-table
                id="eltable"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"

                ref="deliverlight"
                :height="tableHeight"
                highlight-current-row
                size="mini"
                :data="tableData"
                border
                style="width: 100%">
            <el-table-column  type="index" :label="$t('form_serial_number')"  width="50" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="i_pid" label="业务ID" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="dt_createtime" label="时间" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="i_state_mq" label="状态" show-overflow-tooltip>
                <template  slot-scope="scope">
                    <span v-if="scope.row.i_state_mq==0"  class="dib yellow">待发送</span>
                    <span v-if="scope.row.i_state_mq==1"  class="dib green">成功</span>
                    <span v-if="scope.row.i_state_mq==-1" class="dib red">失败</span>
                    <span v-if="scope.row.i_state_mq==2" class="dib blue">已重发</span>
                </template>
            </el-table-column>
            <el-table-column  prop="vc_resplat" label="响应平台" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="vc_queue" label="队列名" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="vc_type" label="队列业务类型" show-overflow-tooltip></el-table-column>
            <el-table-column
                    width="100"
                    label="操作">
                <template slot-scope="scope" >
                    <el-button  type="text" size="mini" v-if="scope.row.i_state_mq==-1" @click="chongfa(scope.row)">重发</el-button>
                    <el-button  type="text" size="mini"  @click="chakan(scope.row)">查看</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--        分页器-->
        <div class="block">
            <div class="pages">
                <div class="choosepage flexother  fl">
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :page-sizes="[10, 20, 30, 40]"
                            :page-size="this.pageSize"
                            layout="total,sizes"
                            :total="this.total"
                    >
                    </el-pagination>
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :pager-count="5"
                            :page-size="this.pageSize"
                            layout="prev, pager, next, jumper"
                            :total="this.total">

                    </el-pagination>
                </div>

            </div>
        </div>
        <el-dialog
                :class="baseerp+'div'"
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                top="7%"
                width="60%"
                height="300"
                title="查看详情"
                :visible.sync="detailDialog"
                v-if="detailDialog"
        >
            <detail-page :data="detailData" @close="closeDetail"></detail-page>
        </el-dialog>
    </div>
</template>

<script>
    import {baseerp} from "@/utils/baseUrl";
    import * as API from "./api";
    import {mapActions} from "vuex";
    import DetailPage from "./component/DetailPage";

    export default{
        name:'busyConfig',
        components:{
            DetailPage,

        },

        data(){
            return{
                state:-1,
                stateList:[{key:'',label:'全部'},{key:0,label:'待处理'},{key:1,label:'成功'},{key:-1,label:'失败'},{key:2,label:'已重发'}],
                currentPage:1,
                pageSize:10,
                total:0,
                baseerp:'',
                tableData: [],
                tableHeight:0,//列表高度
                detailDialog:false,
                detailData:{},
                searchTime:[],
                i_pid:'',
                vc_search:'',
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },

        mounted(){
            this.$nextTick(()=>{
                this.onResize();

            })
            this.getDay()

            //公共样式
            this.baseerp=baseerp
            this.getMqList()
            // this.$nextTick(function () {
            //     this.heightAuto();
            // window.addEventListener('resize',this.onResize);

            // });

        },

        beforeDestroy() {
            // window.removeEventListener('resize',this.heightAuto)
        },
        methods:{
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-80

                // console.log(this.tableHeight)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            ...mapActions(["getCurrentMenuId"]),
            //高度

            heightAuto(){
                // this.$nextTick(()=>{
                //     document.getElementById('body').getBoundingClientRect().top
                // })
                this.tableHeight = window.innerHeight - document.getElementById('body').getBoundingClientRect().top -48 -36    ;

                // console.log(this.tableHeight)
                // console.log(document.getElementById('body').getBoundingClientRect().top)
                // console.log(window.innerHeight)
                // console.log()
            },


            //关闭弹框
            close(){
                this.detailDialog=false
            },
            //页面搜索
            chooseStatus(){
                this.currentPage=1
                this.getMqList()

            },
            dateChange(){
                this.startTime=this.searchTime[0]
                this.endTime=this.searchTime[1]
                this.currentPage=1;
                this.getMqList();
            },
            chongfa(val){
                this.$confirm('是否继续重发','提示',{
                    confirmButtonText:'继续',
                    cancelButtonText:'取消',
                    type:'warning'
                }).then(async()=>{
                    this.resendMq(val.i_id)
                }).catch(()=>{
                    this.$message({
                        type:'info',
                        message:'已取消'
                    })
                })
            },
            //分页
            handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
                this.pageSize = val;    //动态改变
                this.getMqList()
            },
            handleCurrentChange(val) {
                // console.log(`当前页: ${val}`);
                this.currentPage = val;    //动态改变
                this.getMqList()
            },
            chakan(val){
                this.detailData=val
                this.detailDialog=true
            },
            closeDetail(){
                this.detailDialog=false

            },
            //业务配置列表查询
            async getMqList() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    search:this.Searchdata,
                    currentPage: this.currentPage,
                    pageSize: this.pageSize,
                    startDate:this.startTime,
                    endDate:this.endTime,
                    i_pid:this.i_pid,
                    i_state_mq:this.state,
                    vc_search:this.vc_search,
                }
                let res = await API.getMqList(params);
                if (res.code == 1) {
                    this.tableData=res.data
                    this.total=res.total
                    // console.log(res)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async resendMq(i_id) {
                let params = {
                    i_id:i_id
                }
                let res = await API.resendMq(params);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.getMqList()
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            getDay(){
                const date=new Date();
                const y=date.getFullYear()
                const m=(date.getMonth()+1).toString().padStart(2,'0');
                const prem=date.getMonth().toString().padStart(2,'0');
                const d=date.getDate().toString().padStart(2,'0');
                this.startTime=y+'-'+m+'-'+'01';
                this.endTime=y+'-'+m+'-'+d;
                this.preMDate=y+'-'+prem+'-'+d;
                this.searchTime=[ this.startTime,this.endTime]
            },
            getDateString(date){
                let data=date;
                let day=data.substring(0,10);
                // console.log(day,this.preMDate)
                // console.log(day>=this.preMDate)
                if(day>=this.preMDate){
                    return true
                }else {
                    return false
                }
            },
        },

    }
</script>
<style lang="scss" scoped>
    .flexcenter{
        min-width: 39.286rem;
        width: 100%;
        height: 2.857rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0.857rem;
    }
    /deep/{
        .el-table--enable-row-transition{
            /*min-width: 53.571rem !important;*/
        }
        .el-button--text{
            padding: 0 !important;
            margin-left: 0 !important;
            margin-right: 10px;
        }
        .el-tabs__content{
            /*height: 90% !important;*/
            overflow: visible !important;
            height:calc(100% - 0.357rem) !important;
        }
    }
    /deep/.is-leaf .cell .el-checkbox__input{
        display: none;
    }
    .m{
        padding-top: 1.429rem;
    }
    .flexother {
        display: flex;
        /*flex-flow: wrap;*/
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }

    .fr{
        float:right;
    }

    .cl{
        clear: both;
    }
    .input{
        width: 14.286rem;
    }
    /*.mrt20{*/
    /*    margin-top: 1.429rem;*/
    /*}*/
    .mrl20{
        margin-left: 1.429rem;
    }
    .mrb20{
        margin-right: 1.429rem;
    }
    .mrr20{
        margin-right: 1.429rem;
    }

    .chooseheader{
        width:100%;
    }

    .choosepage{
        /*min-width: 42.571rem;*/
        width:90%
    }
    .left{
        width: 17.857rem;
    }
    .red{
        color: red;
    }
    .green{
        color: green;
    }
    .yellow{
        color: #ffbe06;
    }
    .blue{
        color: #409EFF;
    }
</style>